// https://icseng.atlassian.net/wiki/x/aBD3Bw
import axios, { type AxiosResponse } from '@fs/zion-axios'
import { ROOTSTECH_SERVICE as SERVICE } from '../../serviceNames'

type AccessState = 'PENDING' | 'APPROVED' | 'DECLINED' | 'REVOKED' | 'CANCELED'
type AccessGroup = {
  type: string
  region?: string
  contentLocale?: string
  name?: string
}

const BASE = `${SERVICE}/dashboard-authorizer/`
const STATE = `state`

export const getAccessRequisitions = async (): Promise<AxiosResponse> => axios.get(BASE)
export const getAccessRequisition = async (id: string): Promise<AxiosResponse> => axios.get(`${BASE}${id}`)
export const getCurrentUserAccessRequisition = async (cisId: string): Promise<AxiosResponse> =>
  axios.get(BASE, { params: { cisId } })
export const getAccessRequisitionsEntries = async (params: Record<string, string>): Promise<AxiosResponse> =>
  axios.get(BASE, { params })

export const createAccessRequisitionEntry = async ({
  duration,
  expiration,
  group,
}: {
  duration?: string
  expiration?: string
  group: AccessGroup
}): Promise<AxiosResponse> => axios.post(BASE, { duration, expiration, group })

export const updateAccessRequisitionState = async (id: string, accessState: AccessState): Promise<AxiosResponse> =>
  axios.put(`${BASE}${id}/${STATE}`, { state: accessState })

export const deleteAccessRequisitionEntry = async (id: string): Promise<AxiosResponse> => axios.delete(`${BASE}${id}`)
